module.exports = {
  "contractName": "Nifty",
  "abi": [{
    "constant": true,
    "inputs": [],
    "name": "name",
    "outputs": [{
      "name": "",
      "type": "string"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x06fdde03"
  }, {
    "constant": true,
    "inputs": [{
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "getApproved",
    "outputs": [{
      "name": "",
      "type": "address"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x081812fc"
  }, {
    "constant": false,
    "inputs": [{
      "name": "_to",
      "type": "address"
    }, {
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "approve",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0x095ea7b3"
  }, {
    "constant": true,
    "inputs": [],
    "name": "initialized",
    "outputs": [{
      "name": "",
      "type": "bool"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x158ef93e"
  }, {
    "constant": true,
    "inputs": [],
    "name": "totalSupply",
    "outputs": [{
      "name": "",
      "type": "uint256"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x18160ddd"
  }, {
    "constant": false,
    "inputs": [{
      "name": "_from",
      "type": "address"
    }, {
      "name": "_to",
      "type": "address"
    }, {
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "transferFrom",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0x23b872dd"
  }, {
    "constant": true,
    "inputs": [{
      "name": "_owner",
      "type": "address"
    }, {
      "name": "_index",
      "type": "uint256"
    }],
    "name": "tokenOfOwnerByIndex",
    "outputs": [{
      "name": "",
      "type": "uint256"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x2f745c59"
  }, {
    "constant": false,
    "inputs": [{
      "name": "_from",
      "type": "address"
    }, {
      "name": "_to",
      "type": "address"
    }, {
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "safeTransferFrom",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0x42842e0e"
  }, {
    "constant": true,
    "inputs": [{
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "exists",
    "outputs": [{
      "name": "",
      "type": "bool"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x4f558e79"
  }, {
    "constant": true,
    "inputs": [{
      "name": "_index",
      "type": "uint256"
    }],
    "name": "tokenByIndex",
    "outputs": [{
      "name": "",
      "type": "uint256"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x4f6ccce7"
  }, {
    "constant": true,
    "inputs": [{
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "ownerOf",
    "outputs": [{
      "name": "",
      "type": "address"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x6352211e"
  }, {
    "constant": true,
    "inputs": [{
      "name": "_owner",
      "type": "address"
    }],
    "name": "balanceOf",
    "outputs": [{
      "name": "",
      "type": "uint256"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x70a08231"
  }, {
    "constant": true,
    "inputs": [],
    "name": "metadataUri",
    "outputs": [{
      "name": "",
      "type": "string"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x77a4d559"
  }, {
    "constant": true,
    "inputs": [],
    "name": "owner",
    "outputs": [{
      "name": "",
      "type": "address"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x8da5cb5b"
  }, {
    "constant": true,
    "inputs": [],
    "name": "symbol",
    "outputs": [{
      "name": "",
      "type": "string"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x95d89b41"
  }, {
    "constant": false,
    "inputs": [{
      "name": "_to",
      "type": "address"
    }, {
      "name": "_approved",
      "type": "bool"
    }],
    "name": "setApprovalForAll",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0xa22cb465"
  }, {
    "constant": false,
    "inputs": [{
      "name": "_from",
      "type": "address"
    }, {
      "name": "_to",
      "type": "address"
    }, {
      "name": "_tokenId",
      "type": "uint256"
    }, {
      "name": "_data",
      "type": "bytes"
    }],
    "name": "safeTransferFrom",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0xb88d4fde"
  }, {
    "constant": true,
    "inputs": [{
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "tokenURI",
    "outputs": [{
      "name": "",
      "type": "string"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0xc87b56dd"
  }, {
    "constant": true,
    "inputs": [{
      "name": "_owner",
      "type": "address"
    }, {
      "name": "_operator",
      "type": "address"
    }],
    "name": "isApprovedForAll",
    "outputs": [{
      "name": "",
      "type": "bool"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0xe985e9c5"
  }, {
    "constant": false,
    "inputs": [{
      "name": "newOwner",
      "type": "address"
    }],
    "name": "transferOwnership",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0xf2fde38b"
  }, {
    "inputs": [{
      "name": "_name",
      "type": "string"
    }, {
      "name": "_symbol",
      "type": "string"
    }],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "constructor",
    "signature": "constructor"
  }, {
    "anonymous": false,
    "inputs": [{
      "indexed": true,
      "name": "previousOwner",
      "type": "address"
    }, {
      "indexed": true,
      "name": "newOwner",
      "type": "address"
    }],
    "name": "OwnershipTransferred",
    "type": "event",
    "signature": "0x8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0"
  }, {
    "anonymous": false,
    "inputs": [{
      "indexed": true,
      "name": "_from",
      "type": "address"
    }, {
      "indexed": true,
      "name": "_to",
      "type": "address"
    }, {
      "indexed": false,
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "Transfer",
    "type": "event",
    "signature": "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef"
  }, {
    "anonymous": false,
    "inputs": [{
      "indexed": true,
      "name": "_owner",
      "type": "address"
    }, {
      "indexed": true,
      "name": "_approved",
      "type": "address"
    }, {
      "indexed": false,
      "name": "_tokenId",
      "type": "uint256"
    }],
    "name": "Approval",
    "type": "event",
    "signature": "0x8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925"
  }, {
    "anonymous": false,
    "inputs": [{
      "indexed": true,
      "name": "_owner",
      "type": "address"
    }, {
      "indexed": true,
      "name": "_operator",
      "type": "address"
    }, {
      "indexed": false,
      "name": "_approved",
      "type": "bool"
    }],
    "name": "ApprovalForAll",
    "type": "event",
    "signature": "0x17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31"
  }, {
    "constant": false,
    "inputs": [{
      "name": "_owner",
      "type": "address"
    }, {
      "name": "_name",
      "type": "string"
    }, {
      "name": "_symbol",
      "type": "string"
    }, {
      "name": "_metadataUri",
      "type": "string"
    }],
    "name": "initialize",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0x5f1e6f6d"
  }, {
    "constant": false,
    "inputs": [{
      "name": "_to",
      "type": "address"
    }, {
      "name": "_tokenURI",
      "type": "string"
    }],
    "name": "mint",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0xd0def521"
  }, {
    "constant": true,
    "inputs": [],
    "name": "getCollection",
    "outputs": [{
      "name": "",
      "type": "address"
    }, {
      "name": "",
      "type": "string"
    }, {
      "name": "",
      "type": "string"
    }, {
      "name": "",
      "type": "string"
    }, {
      "name": "",
      "type": "uint256"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x4251921e"
  }],
  "bytecode": "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",
  "deployedBytecode": "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",
  "sourceMap": "219:719:0:-;;;308:82;8:9:-1;5:2;;;30:1;27;20:12;5:2;308:82:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;362:5;369:7;1147:5:9;1139;:13;;;;;;;;;;;;:::i;:::-;;1168:7;1158;:17;;;;;;;;;;;;:::i;:::-;;1075:105;;509:10:4;501:5;;:18;;;;;;;;;;;;;;;;;;308:82:0;;219:719;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;",
  "deployedSourceMap": "219:719:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1274:68:9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1274:68:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;1274:68:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3605:111:7;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3605:111:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3021:355;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3021:355:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;562:23:10;;8:9:-1;5:2;;;30:1;27;20:12;5:2;562:23:10;;;;;;;;;;;;;;;;;;;;;;;;;;;2518:87:9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2518:87:9;;;;;;;;;;;;;;;;;;;;;;;5085:316:7;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5085:316:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2199:177:9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2199:177:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;779:157:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;779:157:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;779:157:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;779:157:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;779:157:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6017:225:7;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6017:225:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2461:140;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2461:140:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2934::9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2934:140:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;394:207:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;394:207:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2119:164:7;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2119:164:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1764:142;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1764:142:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;278:25:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;278:25:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;278:25:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;238:20:4;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:4;;;;;;;;;;;;;;;;;;;;;;;;;;;1440:72:9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1440:72:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;1440:72:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4001:205:7;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4001:205:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6929:302;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6929:302:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1705:133:9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1705:133:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;1705:133:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;605:170:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;605:170:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4515:142:7;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4515:142:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:174:4;;8:9:-1;5:2;;;30:1;27;20:12;5:2;832:174:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;1274:68:9;1311:6;1332:5;1325:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1274:68;:::o;3605:111:7:-;3665:7;3687:14;:24;3702:8;3687:24;;;;;;;;;;;;;;;;;;;;;3680:31;;3605:111;;;:::o;3021:355::-;3082:13;3098:17;3106:8;3098:7;:17::i;:::-;3082:33;;3136:5;3129:12;;:3;:12;;;;3121:21;;;;;;;;3170:5;3156:19;;:10;:19;;;:58;;;;3179:35;3196:5;3203:10;3179:16;:35::i;:::-;3156:58;3148:67;;;;;;;;3259:1;3226:35;;:21;3238:8;3226:11;:21::i;:::-;:35;;;;:56;;;;3280:1;3265:17;;:3;:17;;;;3226:56;3222:150;;;3319:3;3292:14;:24;3307:8;3292:24;;;;;;;;;;;;:30;;;;;;;;;;;;;;;;;;3351:3;3335:30;;3344:5;3335:30;;;3356:8;3335:30;;;;;;;;;;;;;;;;;;3222:150;3021:355;;;:::o;562:23:10:-;;;;;;;;;;;;;:::o;2518:87:9:-;2562:7;2584:9;:16;;;;2577:23;;2518:87;:::o;5085:316:7:-;5172:8;1520:39;1538:10;1550:8;1520:17;:39::i;:::-;1512:48;;;;;;;;5213:1;5196:19;;:5;:19;;;;5188:28;;;;;;;;5245:1;5230:17;;:3;:17;;;;5222:26;;;;;;;;5255:30;5269:5;5276:8;5255:13;:30::i;:::-;5291:32;5307:5;5314:8;5291:15;:32::i;:::-;5329:25;5340:3;5345:8;5329:10;:25::i;:::-;5382:3;5366:30;;5375:5;5366:30;;;5387:8;5366:30;;;;;;;;;;;;;;;;;;5085:316;;;;:::o;2199:177:9:-;2281:7;2313:17;2323:6;2313:9;:17::i;:::-;2304:6;:26;2296:35;;;;;;;;2344:11;:19;2356:6;2344:19;;;;;;;;;;;;;;;2364:6;2344:27;;;;;;;;;;;;;;;;;;2337:34;;2199:177;;;;:::o;779:157:0:-;825:7;834:6;842;850;858:7;881:5;;;;;;;;;;;888;895:7;904:11;917:13;:11;:13::i;:::-;873:58;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;779:157;;;;;:::o;6017:225:7:-;6132:8;1520:39;1538:10;1550:8;1520:17;:39::i;:::-;1512:48;;;;;;;;6195:42;6212:5;6219:3;6224:8;6195:42;;;;;;;;;;;;;:16;:42::i;:::-;6017:225;;;;:::o;2461:140::-;2516:4;2528:13;2544:10;:20;2555:8;2544:20;;;;;;;;;;;;;;;;;;;;;2528:36;;2594:1;2577:19;;:5;:19;;;;2570:26;;2461:140;;;;:::o;2934::9:-;2993:7;3025:13;:11;:13::i;:::-;3016:6;:22;3008:31;;;;;;;;3052:9;3062:6;3052:17;;;;;;;;;;;;;;;;;;3045:24;;2934:140;;;:::o;394:207:0:-;714:11:10;;;;;;;;;;;713:12;705:21;;;;;;;;516:6:0;508:5;;:14;;;;;;;;;;;;;;;;;;536:5;528;:13;;;;;;;;;;;;:::i;:::-;;557:7;547;:17;;;;;;;;;;;;:::i;:::-;;584:12;570:11;:26;;;;;;;;;;;;:::i;:::-;;753:4:10;739:11;;:18;;;;;;;;;;;;;;;;;;394:207:0;;;;:::o;2119:164:7:-;2175:7;2190:13;2206:10;:20;2217:8;2206:20;;;;;;;;;;;;;;;;;;;;;2190:36;;2257:1;2240:19;;:5;:19;;;;2232:28;;;;;;;;2273:5;2266:12;;2119:164;;;;:::o;1764:142::-;1820:7;1861:1;1843:20;;:6;:20;;;;1835:29;;;;;;;;1877:16;:24;1894:6;1877:24;;;;;;;;;;;;;;;;1870:31;;1764:142;;;:::o;278:25:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;238:20:4:-;;;;;;;;;;;;;:::o;1440:72:9:-;1479:6;1500:7;1493:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1440:72;:::o;4001:205:7:-;4085:10;4078:17;;:3;:17;;;;4070:26;;;;;;;;4139:9;4102:17;:29;4120:10;4102:29;;;;;;;;;;;;;;;:34;4132:3;4102:34;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;4186:3;4159:42;;4174:10;4159:42;;;4191:9;4159:42;;;;;;;;;;;;;;;;;;;;;;4001:205;;:::o;6929:302::-;7061:8;1520:39;1538:10;1550:8;1520:17;:39::i;:::-;1512:48;;;;;;;;7079:34;7092:5;7099:3;7104:8;7079:12;:34::i;:::-;7172:53;7197:5;7204:3;7209:8;7219:5;7172:24;:53::i;:::-;7164:62;;;;;;;;6929:302;;;;;:::o;1705:133:9:-;1762:6;1784:16;1791:8;1784:6;:16::i;:::-;1776:25;;;;;;;;1814:9;:19;1824:8;1814:19;;;;;;;;;;;1807:26;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1705:133;;;:::o;605:170:0:-;673:15;653:5:4;;;;;;;;;;;639:19;;:10;:19;;;631:28;;;;;;;;691:9:0;:16;;;;673:34;;713:19;719:3;724:7;713:5;:19::i;:::-;738:32;751:7;760:9;738:12;:32::i;:::-;605:170;;;:::o;4515:142:7:-;4597:4;4616:17;:25;4634:6;4616:25;;;;;;;;;;;;;;;:36;4642:9;4616:36;;;;;;;;;;;;;;;;;;;;;;;;;4609:43;;4515:142;;;;:::o;832:174:4:-;653:5;;;;;;;;;;;639:19;;:10;:19;;;631:28;;;;;;;;928:1;908:22;;:8;:22;;;;900:31;;;;;;;;970:8;942:37;;963:5;;;;;;;;;;;942:37;;;;;;;;;;;;993:8;985:5;;:16;;;;;;;;;;;;;;;;;;832:174;:::o;7578:240:7:-;7664:4;7676:13;7692:17;7700:8;7692:7;:17::i;:::-;7676:33;;7734:5;7722:17;;:8;:17;;;:54;;;;7768:8;7743:33;;:21;7755:8;7743:11;:21::i;:::-;:33;;;7722:54;:91;;;;7780:33;7797:5;7804:8;7780:16;:33::i;:::-;7722:91;7715:98;;7578:240;;;;;:::o;8887:265::-;8988:6;8967:27;;:17;8975:8;8967:7;:17::i;:::-;:27;;;8959:36;;;;;;;;9041:1;9005:38;;:14;:24;9020:8;9005:24;;;;;;;;;;;;;;;;;;;;;:38;;;;9001:147;;;9088:1;9053:14;:24;9068:8;9053:24;;;;;;;;;;;;:37;;;;;;;;;;;;;;;;;;9128:1;9103:38;;9112:6;9103:38;;;9132:8;9103:38;;;;;;;;;;;;;;;;;;9001:147;8887:265;;:::o;4202:856:9:-;4320:18;4373:22;4436:17;4275:38;4297:5;4304:8;4275:21;:38::i;:::-;4341:16;:26;4358:8;4341:26;;;;;;;;;;;;4320:47;;4398:32;4428:1;4398:11;:18;4410:5;4398:18;;;;;;;;;;;;;;;:25;;;;:29;;:32;;;;:::i;:::-;4373:57;;4456:11;:18;4468:5;4456:18;;;;;;;;;;;;;;;4475:14;4456:34;;;;;;;;;;;;;;;;;;4436:54;;4530:9;4497:11;:18;4509:5;4497:18;;;;;;;;;;;;;;;4516:10;4497:30;;;;;;;;;;;;;;;;;:42;;;;4582:1;4545:11;:18;4557:5;4545:18;;;;;;;;;;;;;;;4564:14;4545:34;;;;;;;;;;;;;;;;;:38;;;;4944:11;:18;4956:5;4944:18;;;;;;;;;;;;;;;:27;;;;;;;;;;;;:::i;:::-;;5006:1;4977:16;:26;4994:8;4977:26;;;;;;;;;;;:30;;;;5043:10;5013:16;:27;5030:9;5013:27;;;;;;;;;;;:40;;;;4202:856;;;;;:::o;3697:226::-;3800:14;3763:31;3780:3;3785:8;3763:16;:31::i;:::-;3817:11;:16;3829:3;3817:16;;;;;;;;;;;;;;;:23;;;;3800:40;;3846:11;:16;3858:3;3846:16;;;;;;;;;;;;;;;3868:8;3846:31;;39:1:-1;33:3;27:10;23:18;57:10;52:3;45:23;79:10;72:17;;0:93;3846:31:9;;;;;;;;;;;;;;;;;;;;;;3912:6;3883:16;:26;3900:8;3883:26;;;;;;;;;;;:35;;;;3697:226;;;:::o;10623:328:7:-;10762:4;10830:13;10781:16;:3;:14;;;:16::i;:::-;10780:17;10776:49;;;10814:4;10807:11;;;;10776:49;10861:3;10846:36;;;10883:5;10890:8;10900:5;10846:60;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;10846:60:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;10846:60:7;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;10846:60:7;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;10846:60:7;;;;;;;;;;;;;;;;10830:76;;604:10;10930:15;;10920:25;;;:6;:25;;;;10912:34;;10623:328;;;;;;;;:::o;5324:172:9:-;5385:26;5397:3;5402:8;5385:11;:26::i;:::-;5445:9;:16;;;;5418:14;:24;5433:8;5418:24;;;;;;;;;;;:43;;;;5467:9;5482:8;5467:24;;39:1:-1;33:3;27:10;23:18;57:10;52:3;45:23;79:10;72:17;;0:93;5467:24:9;;;;;;;;;;;;;;;;;;;;;;5324:172;;:::o;3304:130::-;3380:16;3387:8;3380:6;:16::i;:::-;3372:25;;;;;;;;3425:4;3403:9;:19;3413:8;3403:19;;;;;;;;;;;:26;;;;;;;;;;;;:::i;:::-;;3304:130;;:::o;9898:214:7:-;10000:5;9979:26;;:17;9987:8;9979:7;:17::i;:::-;:26;;;9971:35;;;;;;;;10038:30;10066:1;10038:16;:23;10055:5;10038:23;;;;;;;;;;;;;;;;:27;;:30;;;;:::i;:::-;10012:16;:23;10029:5;10012:23;;;;;;;;;;;;;;;:56;;;;10105:1;10074:10;:20;10085:8;10074:20;;;;;;;;;;;;:33;;;;;;;;;;;;;;;;;;9898:214;;:::o;836:110:3:-;894:7;921:1;916;:6;;909:14;;;;;;940:1;936;:5;929:12;;836:110;;;;:::o;9415:204:7:-;9521:1;9489:34;;:10;:20;9500:8;9489:20;;;;;;;;;;;;;;;;;;;;;:34;;;9481:43;;;;;;;;9553:3;9530:10;:20;9541:8;9530:20;;;;;;;;;;;;:26;;;;;;;;;;;;;;;;;;9586:28;9612:1;9586:16;:21;9603:3;9586:21;;;;;;;;;;;;;;;;:25;;:28;;;;:::i;:::-;9562:16;:21;9579:3;9562:21;;;;;;;;;;;;;;;:52;;;;9415:204;;:::o;438:568:2:-;495:4;507:12;922:4;910:17;902:25;;1000:1;993:4;:8;986:15;;438:568;;;;:::o;8072:169:7:-;8156:1;8141:17;;:3;:17;;;;8133:26;;;;;;;;8165:25;8176:3;8181:8;8165:10;:25::i;:::-;8222:3;8201:35;;8218:1;8201:35;;;8227:8;8201:35;;;;;;;;;;;;;;;;;;8072:169;;:::o;1008:123:3:-;1066:9;1091:1;1087;:5;1083:9;;1110:1;1105;:6;;1098:14;;;;;;1125:1;1118:8;;1008:123;;;;:::o;219:719:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o",
  "source": "pragma solidity ^0.4.18;\n\nimport \"zos-lib/contracts/migrations/Initializable.sol\";\nimport \"openzeppelin-solidity/contracts/token/ERC721/ERC721Token.sol\";\nimport \"openzeppelin-solidity/contracts/ownership/Ownable.sol\";\n\ncontract Nifty is ERC721Token, Ownable, Initializable {\n\n  string public metadataUri;\n\n  constructor(string _name, string _symbol) ERC721Token(_name, _symbol) public {\n  }\n\n  function initialize(address _owner, string _name, string _symbol, string _metadataUri) isInitializer public {\n    owner = _owner;\n    name_ = _name;\n    symbol_ = _symbol;\n    metadataUri = _metadataUri;\n  }\n\n  function mint(address _to, string _tokenURI) onlyOwner public {\n    uint256 tokenId = allTokens.length;\n    _mint(_to, tokenId);\n    _setTokenURI(tokenId, _tokenURI);\n  }\n\n  function getCollection() public view returns (address, string, string, string, uint256) {\n    return (owner, name_, symbol_, metadataUri, totalSupply());\n  }\n}\n",
  "sourcePath": "/Users/sfeibus/fs/libraries/statesauce/nifty-supply/packages/contracts/contracts/Nifty.sol",
  "ast": {
    "absolutePath": "/Users/sfeibus/fs/libraries/statesauce/nifty-supply/packages/contracts/contracts/Nifty.sol",
    "exportedSymbols": {
      "Nifty": [102]
    },
    "id": 103,
    "nodeType": "SourceUnit",
    "nodes": [{
      "id": 1,
      "literals": ["solidity", "^", "0.4", ".18"],
      "nodeType": "PragmaDirective",
      "src": "0:24:0"
    }, {
      "absolutePath": "zos-lib/contracts/migrations/Initializable.sol",
      "file": "zos-lib/contracts/migrations/Initializable.sol",
      "id": 2,
      "nodeType": "ImportDirective",
      "scope": 103,
      "sourceUnit": 1488,
      "src": "26:56:0",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "absolutePath": "openzeppelin-solidity/contracts/token/ERC721/ERC721Token.sol",
      "file": "openzeppelin-solidity/contracts/token/ERC721/ERC721Token.sol",
      "id": 3,
      "nodeType": "ImportDirective",
      "scope": 103,
      "sourceUnit": 1470,
      "src": "83:70:0",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "absolutePath": "openzeppelin-solidity/contracts/ownership/Ownable.sol",
      "file": "openzeppelin-solidity/contracts/ownership/Ownable.sol",
      "id": 4,
      "nodeType": "ImportDirective",
      "scope": 103,
      "sourceUnit": 339,
      "src": "154:63:0",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "baseContracts": [{
        "arguments": null,
        "baseName": {
          "contractScope": null,
          "id": 5,
          "name": "ERC721Token",
          "nodeType": "UserDefinedTypeName",
          "referencedDeclaration": 1469,
          "src": "237:11:0",
          "typeDescriptions": {
            "typeIdentifier": "t_contract$_ERC721Token_$1469",
            "typeString": "contract ERC721Token"
          }
        },
        "id": 6,
        "nodeType": "InheritanceSpecifier",
        "src": "237:11:0"
      }, {
        "arguments": null,
        "baseName": {
          "contractScope": null,
          "id": 7,
          "name": "Ownable",
          "nodeType": "UserDefinedTypeName",
          "referencedDeclaration": 338,
          "src": "250:7:0",
          "typeDescriptions": {
            "typeIdentifier": "t_contract$_Ownable_$338",
            "typeString": "contract Ownable"
          }
        },
        "id": 8,
        "nodeType": "InheritanceSpecifier",
        "src": "250:7:0"
      }, {
        "arguments": null,
        "baseName": {
          "contractScope": null,
          "id": 9,
          "name": "Initializable",
          "nodeType": "UserDefinedTypeName",
          "referencedDeclaration": 1487,
          "src": "259:13:0",
          "typeDescriptions": {
            "typeIdentifier": "t_contract$_Initializable_$1487",
            "typeString": "contract Initializable"
          }
        },
        "id": 10,
        "nodeType": "InheritanceSpecifier",
        "src": "259:13:0"
      }],
      "contractDependencies": [338, 365, 385, 392, 499, 1082, 1469, 1487],
      "contractKind": "contract",
      "documentation": null,
      "fullyImplemented": true,
      "id": 102,
      "linearizedBaseContracts": [102, 1487, 338, 1469, 1082, 392, 385, 365, 499],
      "name": "Nifty",
      "nodeType": "ContractDefinition",
      "nodes": [{
        "constant": false,
        "id": 12,
        "name": "metadataUri",
        "nodeType": "VariableDeclaration",
        "scope": 102,
        "src": "278:25:0",
        "stateVariable": true,
        "storageLocation": "default",
        "typeDescriptions": {
          "typeIdentifier": "t_string_storage",
          "typeString": "string"
        },
        "typeName": {
          "id": 11,
          "name": "string",
          "nodeType": "ElementaryTypeName",
          "src": "278:6:0",
          "typeDescriptions": {
            "typeIdentifier": "t_string_storage_ptr",
            "typeString": "string"
          }
        },
        "value": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 23,
          "nodeType": "Block",
          "src": "385:5:0",
          "statements": []
        },
        "documentation": null,
        "id": 24,
        "implemented": true,
        "isConstructor": true,
        "isDeclaredConst": false,
        "modifiers": [{
          "arguments": [{
            "argumentTypes": null,
            "id": 19,
            "name": "_name",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 14,
            "src": "362:5:0",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string memory"
            }
          }, {
            "argumentTypes": null,
            "id": 20,
            "name": "_symbol",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 16,
            "src": "369:7:0",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string memory"
            }
          }],
          "id": 21,
          "modifierName": {
            "argumentTypes": null,
            "id": 18,
            "name": "ERC721Token",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 1469,
            "src": "350:11:0",
            "typeDescriptions": {
              "typeIdentifier": "t_type$_t_contract$_ERC721Token_$1469_$",
              "typeString": "type(contract ERC721Token)"
            }
          },
          "nodeType": "ModifierInvocation",
          "src": "350:27:0"
        }],
        "name": "",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 17,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 14,
            "name": "_name",
            "nodeType": "VariableDeclaration",
            "scope": 24,
            "src": "320:12:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 13,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "320:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 16,
            "name": "_symbol",
            "nodeType": "VariableDeclaration",
            "scope": 24,
            "src": "334:14:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 15,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "334:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "319:30:0"
        },
        "payable": false,
        "returnParameters": {
          "id": 22,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "385:0:0"
        },
        "scope": 102,
        "src": "308:82:0",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 53,
          "nodeType": "Block",
          "src": "502:99:0",
          "statements": [{
            "expression": {
              "argumentTypes": null,
              "id": 39,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 37,
                "name": "owner",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 286,
                "src": "508:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 38,
                "name": "_owner",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 26,
                "src": "516:6:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "src": "508:14:0",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "id": 40,
            "nodeType": "ExpressionStatement",
            "src": "508:14:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "id": 43,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 41,
                "name": "name_",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1109,
                "src": "528:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 42,
                "name": "_name",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 28,
                "src": "536:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              },
              "src": "528:13:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage",
                "typeString": "string storage ref"
              }
            },
            "id": 44,
            "nodeType": "ExpressionStatement",
            "src": "528:13:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "id": 47,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 45,
                "name": "symbol_",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1111,
                "src": "547:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 46,
                "name": "_symbol",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 30,
                "src": "557:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              },
              "src": "547:17:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage",
                "typeString": "string storage ref"
              }
            },
            "id": 48,
            "nodeType": "ExpressionStatement",
            "src": "547:17:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "id": 51,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 49,
                "name": "metadataUri",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 12,
                "src": "570:11:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 50,
                "name": "_metadataUri",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 32,
                "src": "584:12:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              },
              "src": "570:26:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage",
                "typeString": "string storage ref"
              }
            },
            "id": 52,
            "nodeType": "ExpressionStatement",
            "src": "570:26:0"
          }]
        },
        "documentation": null,
        "id": 54,
        "implemented": true,
        "isConstructor": false,
        "isDeclaredConst": false,
        "modifiers": [{
          "arguments": null,
          "id": 35,
          "modifierName": {
            "argumentTypes": null,
            "id": 34,
            "name": "isInitializer",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 1486,
            "src": "481:13:0",
            "typeDescriptions": {
              "typeIdentifier": "t_modifier$__$",
              "typeString": "modifier ()"
            }
          },
          "nodeType": "ModifierInvocation",
          "src": "481:13:0"
        }],
        "name": "initialize",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 33,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 26,
            "name": "_owner",
            "nodeType": "VariableDeclaration",
            "scope": 54,
            "src": "414:14:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 25,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "414:7:0",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 28,
            "name": "_name",
            "nodeType": "VariableDeclaration",
            "scope": 54,
            "src": "430:12:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 27,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "430:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 30,
            "name": "_symbol",
            "nodeType": "VariableDeclaration",
            "scope": 54,
            "src": "444:14:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 29,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "444:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 32,
            "name": "_metadataUri",
            "nodeType": "VariableDeclaration",
            "scope": 54,
            "src": "460:19:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 31,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "460:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "413:67:0"
        },
        "payable": false,
        "returnParameters": {
          "id": 36,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "502:0:0"
        },
        "scope": 102,
        "src": "394:207:0",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 78,
          "nodeType": "Block",
          "src": "667:108:0",
          "statements": [{
            "assignments": [64],
            "declarations": [{
              "constant": false,
              "id": 64,
              "name": "tokenId",
              "nodeType": "VariableDeclaration",
              "scope": 79,
              "src": "673:15:0",
              "stateVariable": false,
              "storageLocation": "default",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              },
              "typeName": {
                "id": 63,
                "name": "uint256",
                "nodeType": "ElementaryTypeName",
                "src": "673:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "value": null,
              "visibility": "internal"
            }],
            "id": 67,
            "initialValue": {
              "argumentTypes": null,
              "expression": {
                "argumentTypes": null,
                "id": 65,
                "name": "allTokens",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1123,
                "src": "691:9:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_array$_t_uint256_$dyn_storage",
                  "typeString": "uint256[] storage ref"
                }
              },
              "id": 66,
              "isConstant": false,
              "isLValue": true,
              "isPure": false,
              "lValueRequested": false,
              "memberName": "length",
              "nodeType": "MemberAccess",
              "referencedDeclaration": null,
              "src": "691:16:0",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "nodeType": "VariableDeclarationStatement",
            "src": "673:34:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "id": 69,
                "name": "_to",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 56,
                "src": "719:3:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }, {
                "argumentTypes": null,
                "id": 70,
                "name": "tokenId",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 64,
                "src": "724:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }, {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }],
                "id": 68,
                "name": "_mint",
                "nodeType": "Identifier",
                "overloadedDeclarations": [1389],
                "referencedDeclaration": 1389,
                "src": "713:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                  "typeString": "function (address,uint256)"
                }
              },
              "id": 71,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "713:19:0",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$__$",
                "typeString": "tuple()"
              }
            },
            "id": 72,
            "nodeType": "ExpressionStatement",
            "src": "713:19:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "id": 74,
                "name": "tokenId",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 64,
                "src": "751:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              }, {
                "argumentTypes": null,
                "id": 75,
                "name": "_tokenURI",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 58,
                "src": "760:9:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }],
                "id": 73,
                "name": "_setTokenURI",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1253,
                "src": "738:12:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$_t_string_memory_ptr_$returns$__$",
                  "typeString": "function (uint256,string memory)"
                }
              },
              "id": 76,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "738:32:0",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$__$",
                "typeString": "tuple()"
              }
            },
            "id": 77,
            "nodeType": "ExpressionStatement",
            "src": "738:32:0"
          }]
        },
        "documentation": null,
        "id": 79,
        "implemented": true,
        "isConstructor": false,
        "isDeclaredConst": false,
        "modifiers": [{
          "arguments": null,
          "id": 61,
          "modifierName": {
            "argumentTypes": null,
            "id": 60,
            "name": "onlyOwner",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 312,
            "src": "650:9:0",
            "typeDescriptions": {
              "typeIdentifier": "t_modifier$__$",
              "typeString": "modifier ()"
            }
          },
          "nodeType": "ModifierInvocation",
          "src": "650:9:0"
        }],
        "name": "mint",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 59,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 56,
            "name": "_to",
            "nodeType": "VariableDeclaration",
            "scope": 79,
            "src": "619:11:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 55,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "619:7:0",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 58,
            "name": "_tokenURI",
            "nodeType": "VariableDeclaration",
            "scope": 79,
            "src": "632:16:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 57,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "632:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "618:31:0"
        },
        "payable": false,
        "returnParameters": {
          "id": 62,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "667:0:0"
        },
        "scope": 102,
        "src": "605:170:0",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 100,
          "nodeType": "Block",
          "src": "867:69:0",
          "statements": [{
            "expression": {
              "argumentTypes": null,
              "components": [{
                "argumentTypes": null,
                "id": 92,
                "name": "owner",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 286,
                "src": "881:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }, {
                "argumentTypes": null,
                "id": 93,
                "name": "name_",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1109,
                "src": "888:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              }, {
                "argumentTypes": null,
                "id": 94,
                "name": "symbol_",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1111,
                "src": "895:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              }, {
                "argumentTypes": null,
                "id": 95,
                "name": "metadataUri",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 12,
                "src": "904:11:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              }, {
                "argumentTypes": null,
                "arguments": [],
                "expression": {
                  "argumentTypes": [],
                  "id": 96,
                  "name": "totalSupply",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [1214],
                  "referencedDeclaration": 1214,
                  "src": "917:11:0",
                  "typeDescriptions": {
                    "typeIdentifier": "t_function_internal_view$__$returns$_t_uint256_$",
                    "typeString": "function () view returns (uint256)"
                  }
                },
                "id": 97,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "kind": "functionCall",
                "lValueRequested": false,
                "names": [],
                "nodeType": "FunctionCall",
                "src": "917:13:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              }],
              "id": 98,
              "isConstant": false,
              "isInlineArray": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "nodeType": "TupleExpression",
              "src": "880:51:0",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$_t_address_$_t_string_storage_$_t_string_storage_$_t_string_storage_$_t_uint256_$",
                "typeString": "tuple(address,string storage ref,string storage ref,string storage ref,uint256)"
              }
            },
            "functionReturnParameters": 91,
            "id": 99,
            "nodeType": "Return",
            "src": "873:58:0"
          }]
        },
        "documentation": null,
        "id": 101,
        "implemented": true,
        "isConstructor": false,
        "isDeclaredConst": true,
        "modifiers": [],
        "name": "getCollection",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 80,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "801:2:0"
        },
        "payable": false,
        "returnParameters": {
          "id": 91,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 82,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "825:7:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 81,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "825:7:0",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 84,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "834:6:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 83,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "834:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 86,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "842:6:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 85,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "842:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 88,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "850:6:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 87,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "850:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 90,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "858:7:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 89,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "858:7:0",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "824:42:0"
        },
        "scope": 102,
        "src": "779:157:0",
        "stateMutability": "view",
        "superFunction": null,
        "visibility": "public"
      }],
      "scope": 103,
      "src": "219:719:0"
    }],
    "src": "0:939:0"
  },
  "legacyAST": {
    "absolutePath": "/Users/sfeibus/fs/libraries/statesauce/nifty-supply/packages/contracts/contracts/Nifty.sol",
    "exportedSymbols": {
      "Nifty": [102]
    },
    "id": 103,
    "nodeType": "SourceUnit",
    "nodes": [{
      "id": 1,
      "literals": ["solidity", "^", "0.4", ".18"],
      "nodeType": "PragmaDirective",
      "src": "0:24:0"
    }, {
      "absolutePath": "zos-lib/contracts/migrations/Initializable.sol",
      "file": "zos-lib/contracts/migrations/Initializable.sol",
      "id": 2,
      "nodeType": "ImportDirective",
      "scope": 103,
      "sourceUnit": 1488,
      "src": "26:56:0",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "absolutePath": "openzeppelin-solidity/contracts/token/ERC721/ERC721Token.sol",
      "file": "openzeppelin-solidity/contracts/token/ERC721/ERC721Token.sol",
      "id": 3,
      "nodeType": "ImportDirective",
      "scope": 103,
      "sourceUnit": 1470,
      "src": "83:70:0",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "absolutePath": "openzeppelin-solidity/contracts/ownership/Ownable.sol",
      "file": "openzeppelin-solidity/contracts/ownership/Ownable.sol",
      "id": 4,
      "nodeType": "ImportDirective",
      "scope": 103,
      "sourceUnit": 339,
      "src": "154:63:0",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "baseContracts": [{
        "arguments": null,
        "baseName": {
          "contractScope": null,
          "id": 5,
          "name": "ERC721Token",
          "nodeType": "UserDefinedTypeName",
          "referencedDeclaration": 1469,
          "src": "237:11:0",
          "typeDescriptions": {
            "typeIdentifier": "t_contract$_ERC721Token_$1469",
            "typeString": "contract ERC721Token"
          }
        },
        "id": 6,
        "nodeType": "InheritanceSpecifier",
        "src": "237:11:0"
      }, {
        "arguments": null,
        "baseName": {
          "contractScope": null,
          "id": 7,
          "name": "Ownable",
          "nodeType": "UserDefinedTypeName",
          "referencedDeclaration": 338,
          "src": "250:7:0",
          "typeDescriptions": {
            "typeIdentifier": "t_contract$_Ownable_$338",
            "typeString": "contract Ownable"
          }
        },
        "id": 8,
        "nodeType": "InheritanceSpecifier",
        "src": "250:7:0"
      }, {
        "arguments": null,
        "baseName": {
          "contractScope": null,
          "id": 9,
          "name": "Initializable",
          "nodeType": "UserDefinedTypeName",
          "referencedDeclaration": 1487,
          "src": "259:13:0",
          "typeDescriptions": {
            "typeIdentifier": "t_contract$_Initializable_$1487",
            "typeString": "contract Initializable"
          }
        },
        "id": 10,
        "nodeType": "InheritanceSpecifier",
        "src": "259:13:0"
      }],
      "contractDependencies": [338, 365, 385, 392, 499, 1082, 1469, 1487],
      "contractKind": "contract",
      "documentation": null,
      "fullyImplemented": true,
      "id": 102,
      "linearizedBaseContracts": [102, 1487, 338, 1469, 1082, 392, 385, 365, 499],
      "name": "Nifty",
      "nodeType": "ContractDefinition",
      "nodes": [{
        "constant": false,
        "id": 12,
        "name": "metadataUri",
        "nodeType": "VariableDeclaration",
        "scope": 102,
        "src": "278:25:0",
        "stateVariable": true,
        "storageLocation": "default",
        "typeDescriptions": {
          "typeIdentifier": "t_string_storage",
          "typeString": "string"
        },
        "typeName": {
          "id": 11,
          "name": "string",
          "nodeType": "ElementaryTypeName",
          "src": "278:6:0",
          "typeDescriptions": {
            "typeIdentifier": "t_string_storage_ptr",
            "typeString": "string"
          }
        },
        "value": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 23,
          "nodeType": "Block",
          "src": "385:5:0",
          "statements": []
        },
        "documentation": null,
        "id": 24,
        "implemented": true,
        "isConstructor": true,
        "isDeclaredConst": false,
        "modifiers": [{
          "arguments": [{
            "argumentTypes": null,
            "id": 19,
            "name": "_name",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 14,
            "src": "362:5:0",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string memory"
            }
          }, {
            "argumentTypes": null,
            "id": 20,
            "name": "_symbol",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 16,
            "src": "369:7:0",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string memory"
            }
          }],
          "id": 21,
          "modifierName": {
            "argumentTypes": null,
            "id": 18,
            "name": "ERC721Token",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 1469,
            "src": "350:11:0",
            "typeDescriptions": {
              "typeIdentifier": "t_type$_t_contract$_ERC721Token_$1469_$",
              "typeString": "type(contract ERC721Token)"
            }
          },
          "nodeType": "ModifierInvocation",
          "src": "350:27:0"
        }],
        "name": "",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 17,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 14,
            "name": "_name",
            "nodeType": "VariableDeclaration",
            "scope": 24,
            "src": "320:12:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 13,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "320:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 16,
            "name": "_symbol",
            "nodeType": "VariableDeclaration",
            "scope": 24,
            "src": "334:14:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 15,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "334:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "319:30:0"
        },
        "payable": false,
        "returnParameters": {
          "id": 22,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "385:0:0"
        },
        "scope": 102,
        "src": "308:82:0",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 53,
          "nodeType": "Block",
          "src": "502:99:0",
          "statements": [{
            "expression": {
              "argumentTypes": null,
              "id": 39,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 37,
                "name": "owner",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 286,
                "src": "508:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 38,
                "name": "_owner",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 26,
                "src": "516:6:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "src": "508:14:0",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "id": 40,
            "nodeType": "ExpressionStatement",
            "src": "508:14:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "id": 43,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 41,
                "name": "name_",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1109,
                "src": "528:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 42,
                "name": "_name",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 28,
                "src": "536:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              },
              "src": "528:13:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage",
                "typeString": "string storage ref"
              }
            },
            "id": 44,
            "nodeType": "ExpressionStatement",
            "src": "528:13:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "id": 47,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 45,
                "name": "symbol_",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1111,
                "src": "547:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 46,
                "name": "_symbol",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 30,
                "src": "557:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              },
              "src": "547:17:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage",
                "typeString": "string storage ref"
              }
            },
            "id": 48,
            "nodeType": "ExpressionStatement",
            "src": "547:17:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "id": 51,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 49,
                "name": "metadataUri",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 12,
                "src": "570:11:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 50,
                "name": "_metadataUri",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 32,
                "src": "584:12:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              },
              "src": "570:26:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage",
                "typeString": "string storage ref"
              }
            },
            "id": 52,
            "nodeType": "ExpressionStatement",
            "src": "570:26:0"
          }]
        },
        "documentation": null,
        "id": 54,
        "implemented": true,
        "isConstructor": false,
        "isDeclaredConst": false,
        "modifiers": [{
          "arguments": null,
          "id": 35,
          "modifierName": {
            "argumentTypes": null,
            "id": 34,
            "name": "isInitializer",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 1486,
            "src": "481:13:0",
            "typeDescriptions": {
              "typeIdentifier": "t_modifier$__$",
              "typeString": "modifier ()"
            }
          },
          "nodeType": "ModifierInvocation",
          "src": "481:13:0"
        }],
        "name": "initialize",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 33,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 26,
            "name": "_owner",
            "nodeType": "VariableDeclaration",
            "scope": 54,
            "src": "414:14:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 25,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "414:7:0",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 28,
            "name": "_name",
            "nodeType": "VariableDeclaration",
            "scope": 54,
            "src": "430:12:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 27,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "430:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 30,
            "name": "_symbol",
            "nodeType": "VariableDeclaration",
            "scope": 54,
            "src": "444:14:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 29,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "444:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 32,
            "name": "_metadataUri",
            "nodeType": "VariableDeclaration",
            "scope": 54,
            "src": "460:19:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 31,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "460:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "413:67:0"
        },
        "payable": false,
        "returnParameters": {
          "id": 36,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "502:0:0"
        },
        "scope": 102,
        "src": "394:207:0",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 78,
          "nodeType": "Block",
          "src": "667:108:0",
          "statements": [{
            "assignments": [64],
            "declarations": [{
              "constant": false,
              "id": 64,
              "name": "tokenId",
              "nodeType": "VariableDeclaration",
              "scope": 79,
              "src": "673:15:0",
              "stateVariable": false,
              "storageLocation": "default",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              },
              "typeName": {
                "id": 63,
                "name": "uint256",
                "nodeType": "ElementaryTypeName",
                "src": "673:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "value": null,
              "visibility": "internal"
            }],
            "id": 67,
            "initialValue": {
              "argumentTypes": null,
              "expression": {
                "argumentTypes": null,
                "id": 65,
                "name": "allTokens",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1123,
                "src": "691:9:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_array$_t_uint256_$dyn_storage",
                  "typeString": "uint256[] storage ref"
                }
              },
              "id": 66,
              "isConstant": false,
              "isLValue": true,
              "isPure": false,
              "lValueRequested": false,
              "memberName": "length",
              "nodeType": "MemberAccess",
              "referencedDeclaration": null,
              "src": "691:16:0",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "nodeType": "VariableDeclarationStatement",
            "src": "673:34:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "id": 69,
                "name": "_to",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 56,
                "src": "719:3:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }, {
                "argumentTypes": null,
                "id": 70,
                "name": "tokenId",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 64,
                "src": "724:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }, {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }],
                "id": 68,
                "name": "_mint",
                "nodeType": "Identifier",
                "overloadedDeclarations": [1389],
                "referencedDeclaration": 1389,
                "src": "713:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                  "typeString": "function (address,uint256)"
                }
              },
              "id": 71,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "713:19:0",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$__$",
                "typeString": "tuple()"
              }
            },
            "id": 72,
            "nodeType": "ExpressionStatement",
            "src": "713:19:0"
          }, {
            "expression": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "id": 74,
                "name": "tokenId",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 64,
                "src": "751:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              }, {
                "argumentTypes": null,
                "id": 75,
                "name": "_tokenURI",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 58,
                "src": "760:9:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }],
                "id": 73,
                "name": "_setTokenURI",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1253,
                "src": "738:12:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$_t_string_memory_ptr_$returns$__$",
                  "typeString": "function (uint256,string memory)"
                }
              },
              "id": 76,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "738:32:0",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$__$",
                "typeString": "tuple()"
              }
            },
            "id": 77,
            "nodeType": "ExpressionStatement",
            "src": "738:32:0"
          }]
        },
        "documentation": null,
        "id": 79,
        "implemented": true,
        "isConstructor": false,
        "isDeclaredConst": false,
        "modifiers": [{
          "arguments": null,
          "id": 61,
          "modifierName": {
            "argumentTypes": null,
            "id": 60,
            "name": "onlyOwner",
            "nodeType": "Identifier",
            "overloadedDeclarations": [],
            "referencedDeclaration": 312,
            "src": "650:9:0",
            "typeDescriptions": {
              "typeIdentifier": "t_modifier$__$",
              "typeString": "modifier ()"
            }
          },
          "nodeType": "ModifierInvocation",
          "src": "650:9:0"
        }],
        "name": "mint",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 59,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 56,
            "name": "_to",
            "nodeType": "VariableDeclaration",
            "scope": 79,
            "src": "619:11:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 55,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "619:7:0",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 58,
            "name": "_tokenURI",
            "nodeType": "VariableDeclaration",
            "scope": 79,
            "src": "632:16:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 57,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "632:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "618:31:0"
        },
        "payable": false,
        "returnParameters": {
          "id": 62,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "667:0:0"
        },
        "scope": 102,
        "src": "605:170:0",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 100,
          "nodeType": "Block",
          "src": "867:69:0",
          "statements": [{
            "expression": {
              "argumentTypes": null,
              "components": [{
                "argumentTypes": null,
                "id": 92,
                "name": "owner",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 286,
                "src": "881:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }, {
                "argumentTypes": null,
                "id": 93,
                "name": "name_",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1109,
                "src": "888:5:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              }, {
                "argumentTypes": null,
                "id": 94,
                "name": "symbol_",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 1111,
                "src": "895:7:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              }, {
                "argumentTypes": null,
                "id": 95,
                "name": "metadataUri",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 12,
                "src": "904:11:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage",
                  "typeString": "string storage ref"
                }
              }, {
                "argumentTypes": null,
                "arguments": [],
                "expression": {
                  "argumentTypes": [],
                  "id": 96,
                  "name": "totalSupply",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [1214],
                  "referencedDeclaration": 1214,
                  "src": "917:11:0",
                  "typeDescriptions": {
                    "typeIdentifier": "t_function_internal_view$__$returns$_t_uint256_$",
                    "typeString": "function () view returns (uint256)"
                  }
                },
                "id": 97,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "kind": "functionCall",
                "lValueRequested": false,
                "names": [],
                "nodeType": "FunctionCall",
                "src": "917:13:0",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              }],
              "id": 98,
              "isConstant": false,
              "isInlineArray": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "nodeType": "TupleExpression",
              "src": "880:51:0",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$_t_address_$_t_string_storage_$_t_string_storage_$_t_string_storage_$_t_uint256_$",
                "typeString": "tuple(address,string storage ref,string storage ref,string storage ref,uint256)"
              }
            },
            "functionReturnParameters": 91,
            "id": 99,
            "nodeType": "Return",
            "src": "873:58:0"
          }]
        },
        "documentation": null,
        "id": 101,
        "implemented": true,
        "isConstructor": false,
        "isDeclaredConst": true,
        "modifiers": [],
        "name": "getCollection",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 80,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "801:2:0"
        },
        "payable": false,
        "returnParameters": {
          "id": 91,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 82,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "825:7:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 81,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "825:7:0",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 84,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "834:6:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 83,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "834:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 86,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "842:6:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 85,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "842:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 88,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "850:6:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 87,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "850:6:0",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 90,
            "name": "",
            "nodeType": "VariableDeclaration",
            "scope": 101,
            "src": "858:7:0",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 89,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "858:7:0",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "824:42:0"
        },
        "scope": 102,
        "src": "779:157:0",
        "stateMutability": "view",
        "superFunction": null,
        "visibility": "public"
      }],
      "scope": 103,
      "src": "219:719:0"
    }],
    "src": "0:939:0"
  },
  "compiler": {
    "name": "solc",
    "version": "0.4.24+commit.e67f0147.Emscripten.clang"
  },
  "networks": {
    "15": {
      "events": {},
      "links": {},
      "address": "0x345cA3e014Aaf5dcA488057592ee47305D9B3e10",
      "transactionHash": "0xd5e4937f9582901dfd2c27b0571d910967fb09a2ca54823cf7201f59b28c94b8"
    }
  },
  "schemaVersion": "3.0.0-beta.1",
  "updatedAt": "2018-11-15T21:37:44.500Z"
};